export enum OfferTypeEnum {
  OFFER = 'OFFER',
  PITCH = 'PITCH'
}
